var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 62C48.1208 62 62 48.1208 62 31C62 13.8792 48.1208 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62Z",
    fill: "#FCCC66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7607 47.1061C41.7607 48.5544 40.5866 49.729 39.1379 49.729H22.5868C21.1385 49.729 19.9639 48.5549 19.9639 47.1061V16.5077C19.9639 15.0594 21.138 13.8848 22.5868 13.8848H39.1383C40.5866 13.8848 41.7612 15.0589 41.7612 16.5077V47.1061H41.7607V47.1061Z",
    fill: "#FFFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8232 42.9482H22.3857V18.7295H39.8232V42.9482Z",
    fill: "#486380"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5576 46.3389C32.5576 47.4089 31.6901 48.2764 30.6201 48.2764C29.5501 48.2764 28.6826 47.4089 28.6826 46.3389C28.6826 45.2689 29.5501 44.4014 30.6201 44.4014C31.6901 44.4014 32.5576 45.2689 32.5576 46.3389Z",
    fill: "#34495E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4639 17.1044C35.4639 17.4667 35.1703 17.7603 34.808 17.7603H27.401C27.0386 17.7603 26.7451 17.4667 26.7451 17.1044V16.9625C26.7451 16.6002 27.0386 16.3066 27.401 16.3066H34.8085C35.1708 16.3066 35.4644 16.6002 35.4644 16.9625L35.4639 17.1044Z",
    fill: "#34495E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4014 42.9482H39.8389V18.7295H39.82L22.4014 42.9884V42.9482Z",
    fill: "#49708B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.32801600.svg";
export { ForwardRef as ReactComponent };